module.exports = global["_"] = require("-!./lodash.js");


//////////////////
// WEBPACK FOOTER
// ../~/lodash/lodash.js-exposed
// module id = 207
// module chunks = 3